import vue from "vue";
import {
  getDocumentDescriptionPage, editDocumentDescription, addDocument, deleteDocument,
  getDocumentId, previewDocument,
} from "../../../services/file/explainFile"

const state = {
  dataPages: [],
  dataPage:[],
  detailsData: {},
  addVisible: false,
  dialogVisible: false,
  checkTitle: vue.ls.get('checkTitle'),
};

const getters = {
  addVisible: () => state.addVisible,
  dialogVisible: () => state.dialogVisible,
  dataPages: () => state.dataPages,
  dataPage: () => state.dataPage,
  detailsData: () => state.detailsData,
  checkTitle: () => state.checkTitle ? state.checkTitle : vue.ls.get('checkTitle'),
};

const actions = {
  //说明文档分页列表
  getDocumentDescriptionPage({commit, dispatch}, objc) {
    getDocumentDescriptionPage(objc).then((res) => {
      if (res.code === 0 && res.data) {
        //顶级标题
        let obj={id: '0', name: '顶级标题'};
        obj.children=res.data;
        commit('updateState', {state: 'dataPages', update:[obj]});
      }
    })
  },

  //新增标题
  addDocument({commit, dispatch}, objc) {
    addDocument(objc).then((res) => {
      if (res.code === 0) {
        commit('updateState', {state: 'addVisible', update: false});
        dispatch('getDocumentDescriptionPage')
      }
    })
  },

  //预览文档
  previewDocument({commit, dispatch}, objc) {
    previewDocument(objc).then((res) => {
      if (res.code === 0 && res.data) {
        commit('updateState', {state: 'dataPage', update:res.data});
      }
    })
  },

  //编辑说明文档
  editDocumentDescription({commit, dispatch}, objc) {
    editDocumentDescription(objc).then((res) => {
      if (res.code === 0) {
        commit('updateState', {state: 'dialogVisible', update: false});
        dispatch('getDocumentDescriptionPage')
      }
    })
  },

  //删除标题
  deleteDocument({commit, dispatch}, objc) {
    deleteDocument(objc).then((res) => {
      if (res.code === 0) {
        dispatch('getDocumentDescriptionPage')
      }
    })
  },

  //根据ID查询
  getDocumentId({commit, dispatch}, objc) {
    getDocumentId(objc).then((res) => {
      if (res.code === 0 && res.data) {
        commit('updateState', {state: 'detailsData', update: res.data});
      }
    })
  },

};

const mutations = {
  updateState: (state, payload) => {
    if (payload.state === 'checkTitle') {
      vue.ls.set(payload.state, payload.update);
    }
    vue.set(state, payload.state, payload.update);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/file/modules/explainFile.js